function isRecord(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

function resolveRecord(value) {
  return isRecord(value) ? value : {};
}

function resolveText(value) {
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value).trim();
  }
  return '';
}

function resolveOperations(value) {
  return Array.isArray(value) ? value : [];
}

function resolveChange(operation) {
  const source = resolveRecord(operation);
  const operationType = resolveText(source.operation_type);
  const before = resolveText(source.target_text);
  const after = resolveText(source.replacement_text || source.inserted_text);
  const supported = new Set(['replace_text', 'append_text', 'delete_text']);
  return supported.has(operationType) && (before || after)
    ? { before, after }
    : null;
}

export function resolvePatchPreviewViewModel(value) {
  const payload = resolveRecord(value);
  const preview = resolveRecord(payload.preview);
  return {
    summary: resolveText(preview.summary) || '将更新右侧文档',
    changes: resolveOperations(payload.operations).map(resolveChange).filter(Boolean),
  };
}
